/**
 * PDP v2: keep the add-to-cart button still on a variant change.
 *
 * Dawn's product-info.js (read-only, PRODUCT-INFO-CONTRACT) runs this on every option click:
 *   resetProductFormState()  -> productForm.toggleSubmitButton(true)         // disabled, no text
 *   ...fetch the section...
 *   handleUpdateProductInfo  -> productForm.toggleSubmitButton(false)        // or (true, 'Sold out')
 * and product-form.js's toggleSubmitButton(false) writes window.variantStrings.addToCart -- the
 * store-wide "Add to cart" -- over the section's own label. So the button greyed out for the round
 * trip and came back with different text: the "re-render" the user saw (2026-09-15).
 *
 * The native `disabled` during the round trip STAYS: it is the guard against posting the
 * pre-switch variant id (overlays.spec.js's sequence test waits on it). This patch, loaded only by
 * sections/main-product-v2.liquid, does two things around Dawn's method:
 *   - marks the <product-form> `is-pending` for the round trip, and section-main-product-v2.css
 *     paints that state exactly like the rest state;
 *   - on re-enable, restores the label the section rendered (data-atc-label on the button).
 * Other product-forms on the page (quick-add cards) have no data-atc-label and keep Dawn's text.
 */
(() => {
  const patch = () => {
    const ProductForm = customElements.get('product-form');
    if (!ProductForm) return false;
    const proto = ProductForm.prototype;
    if (proto.__pdpStillButton) return true;
    const original = proto.toggleSubmitButton;
    proto.toggleSubmitButton = function (disable = true, text) {
      // Dawn's reset call is the only one that disables WITHOUT a label: the fetch is in flight.
      const pending = Boolean(disable) && !text;
      this.classList.toggle('is-pending', pending);
      if (disable) {
        original.call(this, true, text);
        return;
      }
      if (!this.submitButton || !this.submitButtonText) {
        original.call(this, false, text);
        return;
      }
      this.submitButton.removeAttribute('disabled');
      const label = this.submitButton.dataset.atcLabel || window.variantStrings.addToCart;
      // Only touch the text node when it actually differs (back from "Sold out"), so the common
      // available -> available switch leaves the button's DOM untouched.
      if (this.submitButtonText.textContent !== label) this.submitButtonText.textContent = label;
    };
    proto.__pdpStillButton = true;
    return true;
  };
  if (!patch()) customElements.whenDefined('product-form').then(patch);
})();
